var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { SdsButtonBase } from './_sds-button-base.lit';
import { property, query, state } from 'lit/decorators.js';
import { initMenuItemsFocusForButtonDropdown } from '../dropdown/menu-items-state-handler';
let SdsButtonDropdownBase = (() => {
    var _a, _SdsButtonDropdownBase_opened_accessor_storage, _SdsButtonDropdownBase_responsive_accessor_storage, _SdsButtonDropdownBase_openedViaKeyboard_accessor_storage, _SdsButtonDropdownBase__trigger_accessor_storage, _SdsButtonDropdownBase__menu_accessor_storage;
    let _classSuper = SdsButtonBase;
    let _opened_decorators;
    let _opened_initializers = [];
    let _opened_extraInitializers = [];
    let _responsive_decorators;
    let _responsive_initializers = [];
    let _responsive_extraInitializers = [];
    let _openedViaKeyboard_decorators;
    let _openedViaKeyboard_initializers = [];
    let _openedViaKeyboard_extraInitializers = [];
    let __trigger_decorators;
    let __trigger_initializers = [];
    let __trigger_extraInitializers = [];
    let __menu_decorators;
    let __menu_initializers = [];
    let __menu_extraInitializers = [];
    return _a = class SdsButtonDropdownBase extends _classSuper {
            constructor() {
                super(...arguments);
                _SdsButtonDropdownBase_opened_accessor_storage.set(this, __runInitializers(this, _opened_initializers, false));
                _SdsButtonDropdownBase_responsive_accessor_storage.set(this, (__runInitializers(this, _opened_extraInitializers), __runInitializers(this, _responsive_initializers, false)));
                _SdsButtonDropdownBase_openedViaKeyboard_accessor_storage.set(this, (__runInitializers(this, _responsive_extraInitializers), __runInitializers(this, _openedViaKeyboard_initializers, false)));
                _SdsButtonDropdownBase__trigger_accessor_storage.set(this, (__runInitializers(this, _openedViaKeyboard_extraInitializers), __runInitializers(this, __trigger_initializers, void 0)));
                _SdsButtonDropdownBase__menu_accessor_storage.set(this, (__runInitializers(this, __trigger_extraInitializers), __runInitializers(this, __menu_initializers, void 0)));
                this.toggleContextMenu = (__runInitializers(this, __menu_extraInitializers), () => {
                    this.opened ? this.closeContextMenu() : this.openContextMenu();
                });
                this.handleKeyDown = (event) => {
                    var _b;
                    const button = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('#trigger');
                    switch (event.code) {
                        case 'Escape':
                            if (this.opened) {
                                this.closeContextMenu();
                            }
                            break;
                        case 'Enter':
                        case 'Space':
                            // Prevent default button behavior (form submission) for dropdown buttons
                            event.preventDefault();
                            event.stopPropagation();
                            if (button) {
                                button.classList.add('sds-button--active');
                            }
                            this.toggleContextMenu();
                            break;
                        case 'ArrowDown':
                            if (!this.opened) {
                                // Prevent the arrow down from being processed by context menu when opening
                                event.preventDefault();
                                event.stopPropagation();
                                if (button) {
                                    button.classList.add('sds-button--active');
                                }
                                this.toggleContextMenu();
                            }
                            break;
                    }
                };
                this.handleMenuClosed = () => {
                    this.cleanupMenuState();
                };
                this.documentClickHandler = (event) => {
                    if (event.target !== this) {
                        this.closeContextMenu(false); // Don't focus trigger when clicking outside
                    }
                };
            }
            /**
             * Controls whether the dropdown is open or closed.
             *
             * @attr {boolean} opened - Indicates if the dropdown is currently opened.
             * @default false
             */
            get opened() { return __classPrivateFieldGet(this, _SdsButtonDropdownBase_opened_accessor_storage, "f"); }
            set opened(value) { __classPrivateFieldSet(this, _SdsButtonDropdownBase_opened_accessor_storage, value, "f"); }
            /**
             * Enables responsive behavior for the dropdown.
             *
             * @attr {boolean} responsive - Determines if the dropdown should adapt to screen size changes.
             * @default false
             */
            get responsive() { return __classPrivateFieldGet(this, _SdsButtonDropdownBase_responsive_accessor_storage, "f"); }
            set responsive(value) { __classPrivateFieldSet(this, _SdsButtonDropdownBase_responsive_accessor_storage, value, "f"); }
            /**
             * Internal state indicating if the dropdown was opened via keyboard interaction.
             * This is used to determine whether to focus the first menu item.
             */
            get openedViaKeyboard() { return __classPrivateFieldGet(this, _SdsButtonDropdownBase_openedViaKeyboard_accessor_storage, "f"); }
            set openedViaKeyboard(value) { __classPrivateFieldSet(this, _SdsButtonDropdownBase_openedViaKeyboard_accessor_storage, value, "f"); }
            get _trigger() { return __classPrivateFieldGet(this, _SdsButtonDropdownBase__trigger_accessor_storage, "f"); }
            set _trigger(value) { __classPrivateFieldSet(this, _SdsButtonDropdownBase__trigger_accessor_storage, value, "f"); }
            get _menu() { return __classPrivateFieldGet(this, _SdsButtonDropdownBase__menu_accessor_storage, "f"); }
            set _menu(value) { __classPrivateFieldSet(this, _SdsButtonDropdownBase__menu_accessor_storage, value, "f"); }
            closeContextMenu(focusTrigger = true) {
                if (this.opened) {
                    this._menu.hide(focusTrigger);
                    this.cleanupMenuState();
                }
            }
            cleanupMenuState() {
                if (this._trigger) {
                    this._trigger.classList.remove('sds-button--selected', 'sds-button--active');
                }
                this.opened = false;
                this.selected = false;
                this.openedViaKeyboard = false;
                this.removeDocumentClickEvent();
            }
            connectedCallback() {
                super.connectedCallback();
                this.closeContextMenu();
            }
            disconnectedCallback() {
                super.disconnectedCallback();
                this.closeContextMenu();
            }
            openContextMenu() {
                this._menu.show(this._trigger, false);
                initMenuItemsFocusForButtonDropdown(this._menu);
                this._menu.minWidth = `${this._trigger.offsetWidth}px`;
                if (this.responsive) {
                    this._menu.getMenu().classList.add('sds-context-menu--responsive');
                }
                this._menu.maxWidth = '240px';
                this.selected = true;
                this.opened = true;
                setTimeout(() => this.addDocumentClickEvent());
            }
            addDocumentClickEvent() {
                document.addEventListener('click', this.documentClickHandler);
            }
            removeDocumentClickEvent() {
                document.removeEventListener('click', this.documentClickHandler);
            }
        },
        _SdsButtonDropdownBase_opened_accessor_storage = new WeakMap(),
        _SdsButtonDropdownBase_responsive_accessor_storage = new WeakMap(),
        _SdsButtonDropdownBase_openedViaKeyboard_accessor_storage = new WeakMap(),
        _SdsButtonDropdownBase__trigger_accessor_storage = new WeakMap(),
        _SdsButtonDropdownBase__menu_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _opened_decorators = [property({ type: Boolean })];
            _responsive_decorators = [property({ type: Boolean })];
            _openedViaKeyboard_decorators = [state()];
            __trigger_decorators = [query('#trigger')];
            __menu_decorators = [query('sds-context-menu')];
            __esDecorate(_a, null, _opened_decorators, { kind: "accessor", name: "opened", static: false, private: false, access: { has: obj => "opened" in obj, get: obj => obj.opened, set: (obj, value) => { obj.opened = value; } }, metadata: _metadata }, _opened_initializers, _opened_extraInitializers);
            __esDecorate(_a, null, _responsive_decorators, { kind: "accessor", name: "responsive", static: false, private: false, access: { has: obj => "responsive" in obj, get: obj => obj.responsive, set: (obj, value) => { obj.responsive = value; } }, metadata: _metadata }, _responsive_initializers, _responsive_extraInitializers);
            __esDecorate(_a, null, _openedViaKeyboard_decorators, { kind: "accessor", name: "openedViaKeyboard", static: false, private: false, access: { has: obj => "openedViaKeyboard" in obj, get: obj => obj.openedViaKeyboard, set: (obj, value) => { obj.openedViaKeyboard = value; } }, metadata: _metadata }, _openedViaKeyboard_initializers, _openedViaKeyboard_extraInitializers);
            __esDecorate(_a, null, __trigger_decorators, { kind: "accessor", name: "_trigger", static: false, private: false, access: { has: obj => "_trigger" in obj, get: obj => obj._trigger, set: (obj, value) => { obj._trigger = value; } }, metadata: _metadata }, __trigger_initializers, __trigger_extraInitializers);
            __esDecorate(_a, null, __menu_decorators, { kind: "accessor", name: "_menu", static: false, private: false, access: { has: obj => "_menu" in obj, get: obj => obj._menu, set: (obj, value) => { obj._menu = value; } }, metadata: _metadata }, __menu_initializers, __menu_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
export { SdsButtonDropdownBase };
